import { useCustomTranslation } from '../../../../../../../../hooks/useCustomTranslation';
import { rootGridTemplateColumns } from '../../../../utils/gridTemplateColumns';
import { SimulationGetTasksFilterSortBy, SortOrder } from '@nexelem/graphne-api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown } from '@fortawesome/pro-light-svg-icons';
import { cn } from '@nexelem/utils';

type SimulationGridHeaderProps = {
  getSortOrder: (column: SimulationGetTasksFilterSortBy) => SortOrder | undefined;
  onSort: (column: SimulationGetTasksFilterSortBy) => void;
};

const SortIcon = ({ order }: { order: SortOrder | undefined }) => {
  if (order === SortOrder.Asc) {
    return <FontAwesomeIcon icon={faArrowUp} />;
  }
  if (order === SortOrder.Desc) {
    return <FontAwesomeIcon icon={faArrowDown} />;
  }
  return null;
};

export const SimulationGridHeader = ({ getSortOrder, onSort }: SimulationGridHeaderProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');

  return (
    <div
      className="box-border grid min-w-405 gap-2 border border-transparent px-2 py-5 text-s14-sb text-text-secondary"
      style={rootGridTemplateColumns}
    >
      {/* Grid Column 1 */}
      <div></div>
      {/* Grid Column 2 */}
      <label className="cursor-pointer" onClick={() => onSort(SimulationGetTasksFilterSortBy.ProductName)}>
        <span
          className={cn(getSortOrder(SimulationGetTasksFilterSortBy.ProductName) && 'text-text-brand', 'flex gap-2')}
        >
          {tWrapper('tableColumnProduct')}
          <SortIcon order={getSortOrder(SimulationGetTasksFilterSortBy.ProductName)} />
        </span>
      </label>
      {/* Grid Column 3 */}
      <label className="cursor-pointer justify-self-end" onClick={() => onSort(SimulationGetTasksFilterSortBy.Amount)}>
        <span className={cn(getSortOrder(SimulationGetTasksFilterSortBy.Amount) && 'text-text-brand', 'flex gap-2')}>
          {tWrapper('tableColumnAmount')}
          <SortIcon order={getSortOrder(SimulationGetTasksFilterSortBy.Amount)} />
        </span>
      </label>
      {/* Grid Column 4 */}
      <div></div>
      {/* Grid Column 5 */}
      <label className="cursor-pointer" onClick={() => onSort(SimulationGetTasksFilterSortBy.QueueName)}>
        <span className={cn(getSortOrder(SimulationGetTasksFilterSortBy.QueueName) && 'text-text-brand', 'flex gap-2')}>
          {tWrapper('tableColumnWorkStation')}
          <SortIcon order={getSortOrder(SimulationGetTasksFilterSortBy.QueueName)} />
        </span>
      </label>
      {/* Grid Column 6 */}
      <div>{tWrapper('tableColumnTechnology')}</div>
      {/* Grid Column 7 */}
      <div></div>
      {/* Grid Column 8 */}
      <label className="cursor-pointer" onClick={() => onSort(SimulationGetTasksFilterSortBy.PlannedStart)}>
        <span
          className={cn(getSortOrder(SimulationGetTasksFilterSortBy.PlannedStart) && 'text-text-brand', 'flex gap-2')}
        >
          {tWrapper('tableColumnPlannedStart')}
          <SortIcon order={getSortOrder(SimulationGetTasksFilterSortBy.PlannedStart)} />
        </span>
      </label>
      <div></div>
    </div>
  );
};
